import React from "react";
import { cn } from "@/lib/utils";

export function CareerCard({ icon: Icon, title, subtitle, right, children, testid, className }) {
  return (
    <section
      className={cn(
        "rounded-2xl border border-border bg-card p-5",
        "shadow-[0_1px_2px_rgba(15,23,42,0.04),0_8px_24px_rgba(15,23,42,0.06)] dark:shadow-none",
        className
      )}
      data-testid={testid}
      aria-label={typeof title === "string" ? title : undefined}
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="flex items-center gap-2.5 min-w-0">
          {Icon && (
            <span className="h-8 w-8 rounded-lg bg-secondary flex items-center justify-center shrink-0" aria-hidden="true">
              <Icon className="h-4 w-4 text-muted-foreground" />
            </span>
          )}
          <div className="min-w-0">
            <h2 className="text-[13px] font-semibold uppercase tracking-[0.14em] text-foreground/90 truncate">{title}</h2>
            {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </div>
        {right && <div className="shrink-0">{right}</div>}
      </div>
      {children}
    </section>
  );
}
